import { NJModal, NJModalContent } from '@engie-group/fluid-design-system-react';
import './ModalTermsConditions.css';
import { useReferentials } from '../../context/ReferentialsContext';

function ModalTermsConditions({ isOpen, handleClose }) {

    const { referentials } = useReferentials();
    const content = referentials?.termsConditions || '';

    return (
        <NJModal
            id="modalFeedback"
            isOpen={isOpen}
        >
            <NJModalContent
                className='modal-terms-conditions-custom-width'
                id="modalTermsConditions"
                onClose={handleClose}
                title="Terms and Conditions of Use"
            >
                <div className='modal-terms-conditions-content'>
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                </div>
            </NJModalContent>
        </NJModal>
    )
}

export default ModalTermsConditions;
